<template>
  <div :class="name">
    <div :class="`${name}__form`">
      <skeleton-basic width="40px" height="22px" />
      <skeleton-basic height="34px" style="margin: 8px 0 32px 0;" />
      <skeleton-basic width="40px" height="22px" />
      <skeleton-basic height="34px" style="margin: 8px 0 32px 0;" />
      <!-- budget -->
      <skeleton-basic width="40px" height="22px" />
      <skeleton-basic width="480px" height="40px" style="margin: 8px 0 4px 0;" />
      <skeleton-basic width="277px" height="34px" style="margin: 0 0 32px 0;" />
      <!-- schedule -->
      <skeleton-basic width="40px" height="22px" />
      <skeleton-basic width="440px" height="34px" style="margin: 8px 0 0 0;" />
    </div>
    <skeleton-basic width="193px" height="326px" style="margin: 8px 0 0 0;" />
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';
const name = 'ttam-splittest-settings-skeleton';
export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    return {
      name,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-splittest-settings-skeleton';
.#{$name} {
  display: flex;
  align-items: flex-end;
  width: 724px;

  &__form {
    margin-right: 22px;
  }
}
</style>
